import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import ar from '../src/assets/locales/ar.json';
import fr from '../src/assets/locales/fr.json';

const resources = {
    fr: {
        translation: fr
    },
    ar: {
        translation: ar
    }
};

// localStorage.setItem("i18n", "fr");
// if (localStorage.getItem('i18n') === 'fr') {
i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    resources,
    // fallbackLng:localStorage.getItem('i18n') === 'fr'?'fr':'ar',
    fallbackLng: 'fr',
    debug: false,
    lng:
  !localStorage.getItem('i18nextLng') || localStorage.getItem('i18nextLng') === 'fr'
    ? 'fr'
    : 'ar',
    // lng: 'fr',
    react: {
        wait: false,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    },
    detection: {
        order: ['queryString', 'cookie'],
        cache: ['cookie']
    },
    interpolation: {
        escapeValue: false
    }
})



export default i18n